import React, { Component } from "react";
import store from "@/redux/store";
import {addDocument, showConfirmModal, hideModal} from "@/reducers/ModalPopup";
import {removeDocument} from "@/reducers/Document";
import { Link, useNavigate, useLocation } from "react-router-dom";

interface ComponentProps {
  [key: string]: any; //Accept any property
  isTeam: boolean;
};

export function DocumentOverview({...props}: ComponentProps): any{
    const addDocumentPopupHandler = ((event) => {
        store.dispatch( addDocument({withSharing: true, isTeam: props?.isTeam, tenants: props?.tenants}) );
        return false; 
    });

const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    return false;
  }
const confirmedRemoveHandler = (props) => {
    store.dispatch(removeDocument(props.item));
    store.dispatch(hideModal(null));
}

    return (
        <>
      <div className="sm:flex sm:items-center pt-4">
        <div className="sm:flex-auto">
          <p className="mt-2 text-sm text-gray-700">
            Hier kunt u al uw belangrijke documenten beheren. Belangrijke documenten zoals paspoort, rijbewijs etc worden beveiligd opgeslagen en kunnen niet worden ingezien door derde.<br/> 
            U kunt uw documenten eventueel delen mocht dit nodig zijn voor de bedrijven welke deze nodig hebben. 
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            onClick={addDocumentPopupHandler}
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Toevoegen document
          </button>
        </div>
      </div>        
        <div className="space-y-10 divide-y divide-gray-900/10">
            <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-1">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                        <tr>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                             Document
                          </th>
                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            Type
                          </th>
                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                            
                          </th>
                        </tr>
                    </thead>
                    
              <tbody className="divide-y divide-gray-200">
                {props.documents && props.documents.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ item?.name }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{ item?.type }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <Link to="" 
                            onClick={(e) => {removeHandler(e, item);}}
                            className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mr-5">
                                Verwijderen<span className="sr-only">, {item.name}</span>
                      </Link>
                    
                    </td>
                    </tr>
                ))}
              </tbody>
                    
                </table>
            </div>
        </div>
        </>
    );
}